import React from 'react';
import OfferCarousel from 'components/Fragments/OfferCarousel/OfferCarousel';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { SEE_ALL_CARDS } from 'partial/OfferManager/offer.constants';

import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Checkbox } from 'components/Checkbox/Checkbox';

export const CompareCardsCheckbox = props => {
  const { offerMetadata, handleCheckboxClick, showCheckbox, cardsSelected } =
    props;
  let offerId = offerMetadata.productId;
  let isChecked = false;
  if (showCheckbox && cardsSelected?.length > 0) {
    let currentItem = cardsSelected.find(item => {
      return item.productId === offerId;
    });
    isChecked = currentItem ? true : false;
  } else {
    isChecked = false;
  }
  return (
    <CSTooltip
      tooltipName="Compare CC"
      title=""
      placement="bottom"
      tooltipContent="Compare this card"
      isDisabledClickEvent
    >
      <FlexContainer className="justify-end items-align-center">
        <Checkbox
          checked={isChecked}
          onChange={() =>
            handleCheckboxClick({ ...offerMetadata, id: offerId })
          }
          name="carousel-cc-offer-checkbox"
          className="margL12"
        />
      </FlexContainer>
    </CSTooltip>
  );
};

function OfferCarouselContainer(props) {
  const {
    offers,
    eventHandler,
    seeAllCards,
    type,
    datatestid,
    containerType,
    pagePosition,
    modulePosition,
    extraAttributes,
    bodyContentType,
    partnersCustomTrackingMeta,
    isOcfPage,
    // exp POD3-1801
    handleCheckboxClick,
    cardsSelected,
    showCheckbox,
    showSeeMoreCardsLink = true,
    creditCardTemplate,
    buttonCTALabel,
    isHighlightFirstCard,
    redirectClickApplyToClickDetails,
    templateCustomClass,
    isOffersPage,
  } = props;
  let trimmedOffers = offers;
  let maxOffers = props.maxOffers ? props.maxOffers : 6;

  if (offers && typeof offers !== 'undefined' && offers.length > 0) {
    const seeAllCardsInserted =
      offers[offers.length - 1]['type'] === SEE_ALL_CARDS;

    if (props.isOcfPage) {
      maxOffers = props.maxOffers ? props.maxOffers : offers.length;
    }

    if (maxOffers && !seeAllCardsInserted) {
      trimmedOffers = offers.slice(0, maxOffers);
    }

    if (seeAllCards && !seeAllCardsInserted && showSeeMoreCardsLink) {
      trimmedOffers = offers.slice(0, maxOffers - 1);
      trimmedOffers.push({ type: SEE_ALL_CARDS, component: seeAllCards });
    }
  }

  return (
    <>
      {typeof trimmedOffers !== 'undefined' && (
        <OfferCarousel
          datatestid={`${datatestid ? datatestid : ''}-OfferCarouselContainer`}
          type={type}
          isOffersPage={isOffersPage}
        >
          {StaticOfferContainer.createRenderedOfferComponents(trimmedOffers, {
            eventHandler,
            containerType,
            pagePosition,
            modulePosition,
            extraAttributes,
            bodyContentType,
            partnersCustomTrackingMeta,
            handleCheckboxClick,
            cardsSelected,
            showCheckbox,
            isOcfPage,
            buttonCTALabel,
            customTopper: props.customTopper,
            customTopperOutsideContainer: props.customTopperOutsideContainer,
            moduleHeading: props.moduleHeading,
            creditCardTemplate,
            isHighlightFirstCard,
            redirectClickApplyToClickDetails,
            templateCustomClass,
          }).map(item => {
            return item;
          })}
        </OfferCarousel>
      )}
    </>
  );
}

export default OfferCarouselContainer;
